module.exports = __webpack_public_path__ + "img/facebook-icon.60ede567.svg";